export * from './post-objekt-art.component';
export * from './post-objekt-art.component.module';